import React, { useState, useEffect } from 'react'
import { createPortal } from 'react-dom'
import { Trans, useTranslation } from 'react-i18next'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { getClassesForUserStatusBg } from '../../utils/commonUtils'
import { DisasterService } from '../../services/disasterRiskManagement/DisasterRiskManagementService'

type EditStatusModalProps = {
  setIsStatusModelOpen: React.Dispatch<React.SetStateAction<boolean>>
  currentTenantId: string
  disasterId: number
  userId?: string
  currentStatus?: string
}

export function EditStatusModal({
  setIsStatusModelOpen,
  currentTenantId,
  disasterId,
  currentStatus,
  userId,
}: EditStatusModalProps) {
  return (
    <Modal
      setIsStatusModelOpen={setIsStatusModelOpen}
      currentTenantId={currentTenantId}
      disasterId={disasterId}
      currentStatus={currentStatus}
      userId={userId}
    />
  )
}

const Modal: React.FC<EditStatusModalProps> = ({
  setIsStatusModelOpen,
  currentTenantId,
  disasterId,
  currentStatus,
  userId,
}) => {
  const queryClient = useQueryClient()

  const [selectedStatus, setSelectedStatus] = useState<string>('')

  const statuses = [
    { label: '安全', value: 'SAFE' },
    { label: '軽傷', value: 'MINOR_INJURY' },
    { label: '重傷', value: 'SERIOUS_INJURY' },
    { label: '未回答', value: 'NOT_ANSWERED' },
  ]

  useEffect(() => {
    if (currentStatus) setSelectedStatus(currentStatus)
  }, [currentStatus])

  const updateUserStatusMutation = useMutation({
    mutationFn: async () => {
      if (!userId || !disasterId)
        throw new Error('Missing userId or disasterId')
      return DisasterService.updateUserStatus(
        disasterId,
        currentTenantId,
        userId,
        selectedStatus
      )
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['user-safety-list', disasterId],
      })
      setIsStatusModelOpen(false)
    },
    onError: (error) => {
      console.error('Failed to update status:', error)
    },
  })

  const handleSave = () => {
    setIsStatusModelOpen(false)
    if (selectedStatus !== currentStatus) {
      updateUserStatusMutation.mutate()
    }
  }

  return createPortal(
    <div className="modal-area without-overlay-bg-modal modal-tsunami-earthquake uk-box-shadow-xlarge">
      <div className="modal-edit color-white bg-grey-80">
        <button
          className="uk-position-top-right uk-margin-small-top close-button"
          onClick={() => setIsStatusModelOpen(false)}
        >
          <Trans>BUTTONS.CLOSE_BUTTON</Trans>X
        </button>

        <p className="uk-margin-remove mt-30">
          安否ステータスの変更が可能です。
        </p>
        <p className="uk-margin-remove">
          代理報告欄の氏名、安否ステータスを確認し変更してください。
        </p>

        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            marginTop: '16px',
          }}
        >
          {statuses.map((s) => (
            <button
              key={s.value}
              onClick={() => setSelectedStatus(s.value)}
              className={`status-button ${
                selectedStatus === s.value
                  ? getClassesForUserStatusBg(selectedStatus)
                  : ''
              }`}
            >
              {s.label}
            </button>
          ))}
        </div>

        <div className="uk-text-right mt-20">
          <button className="save-button" onClick={handleSave}>
            <Trans>BUTTONS.SAVE</Trans>
          </button>
        </div>
      </div>
    </div>,
    document.body
  )
}
